<template>
  <div :class="classes">
      <el-table  :data="current_list" style="width: 100%" :span-method="spanMethod"  @row-dblclick="rowDbclick" :show-header="showHeader" :stripe="stripe" :border="border"
      :empty-text="emptyText"  @select="select" @select-all="selectAll" @selection-change="selectionChange" @cell-click="cellClick" @cell-dblclick="cellDblclick"
      @row-click="rowClick" ref="table" :height="height" :max-height="maxHeight" :row-class-name="rowClassName" :header-row-class-name="headerRowClassName"
      :header-cell-class-name="headerCellClassName" :header-cell-style="headerCellStyleOur" :header-row-style="headerRowStyleOur" :show-overflow-tooltip="showOverflowTooltip"
      :class="isHeaderDefaultStyle?'hasHeaderDefaultStyle':''" :row-key="rowKey" @current-change="setCurrentRow" :highlight-current-row="highlightCurrentRow"
			 :cell-class-name="cellClassName" :cell-style="cellStyle">
        <el-table-column
        type="selection"
        v-if="isSelect"
        :selectable="selectable"
        :reserve-selection="reserveSelection"
        width="55">
        </el-table-column>
          <slot name="before"/>
          <template v-for="(item,index) in labels">
            <el-table-column :prop="item.value" :label="item.label" :width="item.width"  :fit="item.fit" :key="index" :type="item.type"
            :min-width="item.minWidth" :max-width="item.maxWidth" :fixed="item.fixed" :align="item.align" :headerAlign="item.headerAlign"
            :sortable="item.sortable" :sortMethod="item.sortMethod" :render-header="renderHeader">
                <template v-if="item.labels&&item.labels.length>0">
                    <template v-for="(etem,i) in item.labels">
                    <el-table-column :prop="etem.value" :label="etem.label" :width="etem.width"  :fit="etem.fit" :key="i" :type="etem.type"
                :min-width="etem.minWidth" :max-width="etem.maxWidth" :fixed="etem.fixed" :align="item.align" :headerAlign="item.headerAlign"
                :sortable="item.sortable" :sortMethod="item.sortMethod"></el-table-column>
                    </template>
                </template>
            </el-table-column>
          </template>
          <slot/>
          <template slot="append">
              <slot name="append"/>
          </template>
      </el-table>
  </div>
</template>

<script>
// 组件class前缀
import { Table, TableColumn } from 'element-ui'
const prefixCls = 'wt-table'
export default {
  name: 'wt-table',
  props: {
		cellClassName:{
			type:[Function,String]
		},
		cellStyle:{
			type:[Function,Object]
		},
    spanMethod: {
      type: Function
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    components: {
      'el-table': Table,
      'el-table-column': TableColumn
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
    labels: {
      type: Array,
      default: function () {
        return []
      }
    },
    stripe: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: ''
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    height: {
      type: [Number, String]
    },
    maxHeight: {
      type: [Number, String]
    },
    rowClassName: {
      type: [String, Function]
    },
    headerRowClassName: {
      type: [String, Function]
    },
    headerCellClassName: {
      type: [String, Function]
    },
    headerCellStyle: {
      type: [Object, Function]
    },
    // 表头是否设置为默认背景色
    isHeaderDefaultStyle: {
      type: Boolean,
      default: false
    },
    headerRowStyle: {
      type: [Object, Function]
    },
    selectable: {
      type: [Object, Function]
    },
    rowKey: {
      type: [String, Function]
    },
    reserveSelection: {
      type: Boolean
    },
    highlightCurrentRow:{
      type:Boolean
		},
		showOverflowTooltip:{
			type:Boolean
		},
		renderHeader:{
			type:Function
		}
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    headerRowStyleOur () {
      return this.isHeaderDefaultStyle ? { ...this.headerRowStyle, ...this.defaultHeaderStyle } : this.headerRowStyle
    },
    headerCellStyleOur () {
      return this.isHeaderDefaultStyle ? { ...this.headerCellStyle, ...this.defaultHeaderStyle } : this.headerCellStyle
    }
  },
  data () {
    return {
      current_list: this.list,
      defaultHeaderStyle: {
        'background-color': '#f5f7fa',
        'font-size': '13px',
        'font-weight': 700,
        'color': '#48465b'
      }
    }
  },
  watch: {
    list: {
      handler: function (val) {
        this.current_list = val
      },
      deep: true
    }
  },
  methods: {
    setCurrentRow(row){
      this.$refs.table.setCurrentRow(row);
    },
    rowClick (row, event, column) {
      this.$emit('row-click', row, event, column)
    },
    rowDbclick (val) {
      this.$emit('row-dbclick', val)
    },
    select (selection, row) {
      this.$emit('select', selection, row)
    },
    selectAll (selection) {
      this.$emit('select-all', selection)
    },
    selectionChange (selection) {
      this.$emit('selection-change', selection)
    },
    cellClick (row, column, cell, event) {
      this.$emit('cell-click', row, column, cell, event)
    },
    cellDblclick (row, column, cell, event) {
      this.$emit('cell-dblclick', row, column, cell, event)
    },
    toggleRowSelection (row, selected) {
      this.$refs.table.toggleRowSelection(row, selected)
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    toggleAllSelection () {
      this.$refs.table.toggleAllSelection()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
<style lang="less">
.hasHeaderDefaultStyle{
  thead{
    th{
      .cell{
        font-weight: inherit
      }
    }
  }
}
</style>
